module.exports = __webpack_public_path__ + "static/media/jifenkong.d26d708c.png";